<template>
  <div class="vx-card">
    <div class="vx-card__header text-center p-3">
      <div class="vx-card__title w-full">
        <h4 class="mr-2 inline-block align-middle" v-text="title"></h4>
      </div>
    </div>
    <div class="vx-card__collapsible-content vs-con-loading__container">
      <vs-divider class="m-0"></vs-divider>
      <div class="vx-card__body p-3 text-center" v-if="hasDisplay">
        <spinner v-if="isLoading"></spinner>
        <span v-else v-text="display"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportStatisticsItemCard',
  props: {
    title: {
      type: String
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    display: {
      type: [String, Number]
    }
  },
  computed: {
    hasTitle () {
      return typeof this.title !== 'undefined' && this.title.length > 0 && this.title !== ''
    },
    hasDisplay () {
      switch (typeof this.display) {
        case 'undefined':
          return false
        case 'number':
          return this.display.toString() // TODO: Check why 0 is not being displayed.
        case 'string':
          return this.display.length > 0 && this.display !== ''
      }
    }
  }
}
</script>

<style scoped>

</style>
